import * as ngCore from '@angular/core'

/**
 * Placeholder skeleton loader component for the conversational assistant.
 * Displays animated placeholder messages to indicate loading state
 * while conversation history is being fetched.
 */
@ngCore.Component({
  selector: 'atn-assistant-loader',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {}
